import { environment } from 'src/environments/environment';

export class ParcelasEnvironmentDefinition {
    public hasClients = environment.features.hasClients;
    public fincaName = environment.features.fincaName;
    public fincasName = environment.features.fincasName;
    public sectorName = environment.features.sectorName;
    public sectoresName = environment.features.sectoresName;
    public parcelaName = environment.features.parcelaName;
    public parcelasName = environment.features.parcelasName;
    public showMapas = environment.features.showMapas;
    public showSigPacParcela = environment.features.showSigPacParcela;
    public showSectores = environment.features.showSectores;
    public variedadCanBeVarios = environment.features.variedadCanBeVarios;
    public showAplicadoresActivo = environment.features.showAplicadoresActivo;
    public showDatosMedioambientales = environment.features.showDatosMedioambientales;
    public showParcelasEstacion = environment.features.showParcelasEstacion;
    public showParcelasCodigoTrazabilidad = environment.features.showParcelasCodigoTrazabilidad;
    public customMapColorsList: Record<string,string> = environment.features.customMapColorsList;
    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public otros = environment.features.showParcelasPartida;
    public showParcelasComercioDropdown = environment.features.showParcelasComercioDropdown;
    public showParcelasTurbo = environment.features.showParcelasTurbo;
    public showParcelasLote = environment.features.showParcelasLote;
    public textoSuperficie = environment.features.textoSuperficie;
    public activateApiSIEX = environment.features.activateSIEX;
    public hasPlantas = environment.features.hasPlantas;
    public showTareasMto = environment.features.showTareasMto;
    public showMarcoPlantacion = environment.features.showMarcoPlantacion;
    public showAnyoPlantacion = environment.features.showAnyoPlantacion;
    public showPlantas = environment.features.showPlantas;
    public showPatron = environment.features.showPatron;
    public showParcelasPartida = environment.features.showParcelasPartida;
    public showParcelasComercio = environment.features.showParcelasComercio;
    public showParcelasPozos = environment.features.showParcelasPozos;
}// class;